const InviteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="none"
      viewBox="0 0 16 16"
    >
      <path d="M10.6667 7.99992H13.3334M12 9.33325V6.66659M2.66669 11.9999V11.3333C2.66669 10.8028 2.8774 10.2941 3.25247 9.91904C3.62755 9.54397 4.13625 9.33325 4.66669 9.33325H7.33335C7.86379 9.33325 8.37249 9.54397 8.74757 9.91904C9.12264 10.2941 9.33335 10.8028 9.33335 11.3333V11.9999C9.33335 12.1767 9.26312 12.3463 9.13809 12.4713C9.01307 12.5963 8.8435 12.6666 8.66669 12.6666H3.33335C3.15654 12.6666 2.98697 12.5963 2.86195 12.4713C2.73693 12.3463 2.66669 12.1767 2.66669 11.9999ZM8.00002 5.33325C8.00002 5.86368 7.78931 6.37239 7.41423 6.74747C7.03916 7.12254 6.53045 7.33325 6.00002 7.33325C5.46959 7.33325 4.96088 7.12254 4.58581 6.74747C4.21073 6.37239 4.00002 5.86368 4.00002 5.33325C4.00002 4.80282 4.21073 4.29411 4.58581 3.91904C4.96088 3.54397 5.46959 3.33325 6.00002 3.33325C6.53045 3.33325 7.03916 3.54397 7.41423 3.91904C7.78931 4.29411 8.00002 4.80282 8.00002 5.33325Z" stroke="currentColor"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
};

export default InviteIcon;
